import { Menu as Menu_kojaro } from './Menu.kojaro';
import { Menu as Menu_phosphor } from './Menu.phosphor';
import { Menu as Menu_zoomg } from './Menu.zoomg';
import { Menu as Menu_zoomit } from './Menu.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Menu_kojaro;

    case 'zoomg':
      return Menu_zoomg;

    case 'phosphor':
      return Menu_phosphor;

    default:
      return Menu_zoomit;
  }
};

export const Menu = IconRenderer();
